var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Container, Box, Grid, Button } from "@mui/material";
import { BackButtonWithTitle } from "@opala-ds/react";
import { useHistory } from "react-router-dom";
import styles from "../../components/HomePage/index.module.css";
import { useWebgate } from "@xvia/webgate-connect";
var CartilhaListagemPage = function () {
    var history = useHistory();
    var handleBotaoVoltar = function () {
        window.history.back();
    };
    var novaCartilha = function () {
        history.push("/cartilha-cadastro/0");
    };
    var portalConnect = useWebgate().portalConnect;
    return (_jsxs(Container, __assign({ id: "container-index b2" }, { children: [_jsx(Box, __assign({ className: styles.header }, { children: _jsx(BackButtonWithTitle, { textButton: "Voltar", textTitle: "Cartilhas Informativas", hideBackButton: portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.isRunningInWebview(), onClick: handleBotaoVoltar }) })), _jsx(Box, { children: _jsx("div", { children: _jsx(Grid, __assign({ container: true, spacing: 1, padding: 1 }, { children: _jsx(Grid, __assign({ item: true, xs: 12, sm: 12, md: 12, lg: 12, sx: {
                                textAlign: "right",
                            } }, { children: _jsx(Button, __assign({ variant: "contained", color: "success", onClick: novaCartilha }, { children: "Nova" })) })) })) }) })] })));
};
export default CartilhaListagemPage;
